import Portfolio3 from './Portfolio3'
export default Portfolio3
